import React, { Component } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import NonComplaintReport from "../../Reports/ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence";
import { languageService } from "../../../Language/language.service";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import ToggleButton from "../../../libraries/ToggleButton";
import { Fragment } from "react";
import WorkOrderReportModuleContainer from "../../Reports/WorkOrderReport/Index";
import MH_TableView from "./TableView/TableView";
class MaintenanceHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      maintenanceHistory: [],
      viewMode: "Summary",
      toggleOptions: ["Summary", "Report"],
    };
    this.showDetailedView = this.showDetailedView.bind(this);
  }
  createURL = (baseURL, dateRange, assetId, reportId) => {
    const totalParams = { ...dateRange };
    const encodedDateRange = encodeURIComponent(JSON.stringify(totalParams));
    const params = new URLSearchParams({
      assetId: assetId,
      rId: reportId,
    });

    const fullURL = `${baseURL}?dateRange=${encodedDateRange}&${params.toString()}&getTasks=true`;
    return fullURL;
  };
  geturl = (asset) => {
    return this.createURL(
      "inspection",
      {
        from: new Date("1970-01-01T00:00:00.000Z"),
        to: new Date(),
        today: new Date(),
        inspecSchedule: "Scheduled",
      },
      asset._id,
      36, // id for inspection filter criteria in journeyPlan.service.js to get both injector and maintenance form
    );
  };
  componentDidMount() {
    const { selectedAsset } = this.props;
    let url = this.geturl(selectedAsset);
    this.props.getMaintenanceHistory(`${url}`);
  }
  componentDidUpdate(prevProps) {
    const { actionType } = this.props;
    if (prevProps.actionType != actionType && actionType == "MAINTENANCEHISTORY_READ_SUCCESS") {
      this.setState({
        maintenanceHistory: this.props.maintenanceHistory,
      });
    }
  }
  isApp = () => localStorage.getItem("source");

  showDetailedView(maintenanceHistory, selectedAsset) {
    return (
      <Fragment>
        <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
          {!this.isApp() && (
            <div
              className="report-print"
              style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
              onClick={(e) => window.print()}
            >
              <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
                {languageService("Print Report")}
              </span>
              <SvgIcon icon={printer} size={24} />
            </div>
          )}
        </div>
        <div className="mainContent">
          <NonComplaintReport
            reportName={languageService("Locomotive Maintenance History")}
            inspec={maintenanceHistory}
            selectedAsset={selectedAsset}
            selectedAssetId={selectedAsset._id}
          />
        </div>
      </Fragment>
    );
  }
  render() {
    const { maintenanceHistory } = this.state;
    const { selectedAsset } = this.props;
    return (
      <div className="MH_Container">
        <div
          className="no-print"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", borderBottom: "1px solid #00000033" }}
        >
          <h3 className="VOU_Header" style={{ border: "none" }}>
            {languageService("ASSET MAINTENANCE HISTORY")}
          </h3>
          <ToggleButton options={this.state.toggleOptions} value={this.state.viewMode} onSelected={(v) => this.setState({ viewMode: v })} />
        </div>
        {this.state.viewMode === "Summary" && <MH_TableView selectedAssetId={selectedAsset._id} />}
        <div>{this.state.viewMode === "Report" && this.showDetailedView(maintenanceHistory, selectedAsset)}</div>
      </div>
    );
  }
}
let actionOptions = {
  create: false,
  update: false,
  read: true,
  delete: false,
};
const MaintenanceHistoryContainer = CRUDFunction(MaintenanceHistory, "maintenanceHistory", actionOptions, null, null, "journeyPlan/report");
export default MaintenanceHistoryContainer;



// WEBPACK FOOTER //
// ./src/components/AssetView/MaintenanceHistory/MaintenanceHistory.jsx